import { render, staticRenderFns } from "./dialog-add.vue?vue&type=template&id=2de678c0"
import script from "./dialog-add.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-add.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog-add.vue?vue&type=style&index=0&id=2de678c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports